import { theme } from '../globalStyle/global-styles';
import styled from 'styled-components';

export const ModuleViewWrapper = styled.div`
  height: auto;
  width: 100%;
  display: inline-block;

  .questionsWrapper {
    margin: -8px -16px;
  }
  .event-lang {
    .wrapper {
      margin-bottom: 0;
    }
  }
   
  .containerButtons {
    margin: ${theme.space_size} calc(${theme.space_size} * 2);
    .showAnswers {
      background-color: ${theme.colours.Cultured};
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      font-family: ${theme.fonts.Regular};
      color: ${theme.colours.black_2};
      font-size: 14px;
      padding: 8px;
      font-weight: 400;
      cursor: pointer;
      p {
        ${theme.fonts.Regular};
        font-size: 14px;
      }
      svg.open {
        transform: rotate(180deg);
      }
    }
    .editButton {
      background-color: ${theme.colours.Cultured};
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: ${theme.fonts.Regular};
      color: ${theme.colours.black_2};
      font-size: 14px;
      padding: 8px;
      font-weight: 400;
      cursor: pointer;
    }
  }
`;
export const ModuleViewHeaderWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .badge {
    background-color: #F1F1F1;
    color: #303030;
    width: 58px;
    height: 24px;
    font-weight: 400;
}
  div {
    h2 {
      color: ${theme.colours.blackText};
      font-family: ${theme.fonts.Regular};
      font-weight: 600;
      font-size: 16px !important;
      padding: 0 !important;

      &.thin-title {
        font-size: 14px;
        color: ${theme.colours.gray2};
        font-weight: 400;
      }
    }
  }
  &.thin-title {
    padding-bottom: 7px;
  }
`;
export const ModuleViewBodyWrapper = styled.div`
  background-color: ${theme.colours.white};
  border-radius: 8px;
  /* outline: 0.5px solid ${theme.colours.newOutline}; */
  border: 0.5px solid ${theme.colours.newOutline};
  border-bottom: 1px solid ${theme.colours.newOutline};

  padding: 16px;
  height: 100%;
  @media (max-width: 767px) {
    /* padding-inline-end: 0; */
  }

  .mantine-Checkbox-body {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
  }

  .mantine-Checkbox-inner {
    width: 16px;
    height: 16px;
    .mantine-Checkbox-input {
      width: 16px;
      height: 16px;
      border-radius: 4px;
      border: 1px solid ${theme.colours.blackText};
    }
  }

  .number_input_select_wrapper {
    .input_number_select {
      input {
        border-left: none !important;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
      }
      input.hasError {
        border: 0.5px solid ${theme.colours.error} !important;
      }
    }
    .mantine-Select-input {
      border-radius: 8px !important;
      /* border: 1px solid rgb(200, 200, 200); */
      border-right: 0;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
      width: 73px;
      background-color: #f5f5f5;
    }
  }

  form {
    border-bottom: 1px solid ${theme.colours.BrightGray};
    padding-bottom: 24px;
    padding-top: 16px;
    input.mantine-Select-input,
    input.mantine-DateInput-input {
      &::placeholder {
        color: ${theme.colours.black} !important;
        font-size: 14px;
      }
    }
    label {
      p {
        font-size: 13px;
        color: ${theme.colours.gray2};
        font-family: ${theme.fonts.Medium};
        margin-bottom: 8px;
        margin-inline-start: 7px;
      }
      input,
      textarea {
        background-color: ${theme.colours.Lotion};
        border-color: ${theme.colours.BrightGray};
        border-radius: 12px;
        &::placeholder {
          color: ${theme.colours.black};
          font-size: 14px;
        }
      }
    }
    .phone_num {
      input {
        direction: ltr;
        &:lang(ar) {
          text-align: right;
        }
        &::placeholder {
          color: ${theme.colours.silverChalice};
          font-size: 14px;
        }
      }
    }

    .gray_placeholder {
      input {
        &::placeholder {
          color: ${theme.colours.silverChalice};
        }
      }
    }
    .mantine-Select-wrapper {
      input {
        background-color: ${theme.colours.Lotion};
        border-color: ${theme.colours.BrightGray} !important;
        border-radius: 8px !important;
      }
    }
    input.mantine-DateInput-input {
      font-family: ${theme.fonts.Regular};
      background-color: ${theme.colours.Lotion};
      border-color: ${theme.colours.BrightGray} !important;
      border-radius: 12px !important;
    }
    .mantine-DateInput-root {
      line-height: 14px;
      label {
        font-size: 13px;
        color: ${theme.colours.gray2};
        font-family: ${theme.fonts.Medium};
        margin-bottom: 8px;
      }
      .mantine-Input-input {
        &:lang(ar) {
          text-align: right;
        }
        background-color: ${theme.colours.Lotion};
        border-radius: 12px;
        border-color: ${theme.colours.SpanishGray};
        height: 32px;
        min-height: 32px !important;
      }
    }
    .mantine-Grid-root {
      width: 100%;
    }
    .mantine-Grid-root.block {
      border-bottom: 1px solid ${theme.colours.BrightGray};
    }
    .mantine-Grid-root.last_block {
      input {
        &:lang(ar) {
          text-align: right;
        }
        &:lang(en) {
          text-align: left;
        }
      }
      label {
        input {
          &:lang(ar) {
            text-align: right;
          }
          &:lang(en) {
            text-align: left;
          }

          &::placeholder {
            color: ${theme.colours.silverChalice};
          }
        }
      }
    }
    .phone_wrapper {
      .hint {
        margin-bottom: 10px;
        line-height: 22px;
        text-align: initial;
        min-height: 32px;
        p {
          background-color: ${theme.colours.warnning_color};
          color: ${theme.colours.warnning_text_color};
          padding: 7px 12px;
          font-size: 13px;
          border-radius: 8px;
          font-family: ${theme.fonts.Regular};
        }
        p.success {
          background-color: ${theme.colours.success_color};
          color: ${theme.colours.success_text_color};
        }
      }
      button.search {
        height: 40px;
        background-color: ${theme.colours.AntiFlashWhite};
        color: ${theme.colours.black};
        border-radius: 12px;
        margin-bottom: 8px;
        padding: 9px 30px;
      }
    }
    .domain_wrapper {
      input {
        direction: ltr;
        text-align: right;
        padding-left: 35%;
      }
      span.domain {
        left: 10px;
        right: unset;
        color: ${theme.colours.mainBlue};
        font-weight: 400;
        font-size: 14px;
        position: absolute;
        direction: rtl;
        top: 14px;
        width: max-content;
        line-height: 1;
      }
    }
    .hide_label {
      label {
        p {
          opacity: 0;
          white-space: nowrap !important;
          @media (max-width: 990px) {
            margin-bottom: 27px;
          }
        }
      }
    }
    .nowrap {
      label {
        p {
          white-space: nowrap;
          @media (max-width: 500px) {
            white-space: break-spaces;
          }
        }
      }
    }
    .full_width {
      width: 100%;
    }
  }

  #add-appointment {
    border-bottom: 0;
    /* input {
      margin-bottom: 16px;
      border-radius: 8px;
    } */
    input[type='radio'] {
      margin-bottom: 0;
    }
    .mantine-InputWrapper-root p {
      margin-bottom: 0;
    }
    label {
      color: ${theme.colours.blackText};
      font-size: 14px;
      p {
        color: ${theme.colours.blackText};
        font-size: 14px;
      }
    }
  }
  #add-new-appointment form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .action_container {
    padding: 16px 0 0;
    button {
      border-radius: 12px;
      min-width: 85px;
      height: 36px;
      background-color: ${theme.colours.AntiFlashWhite};
      color: ${theme.colours.black};
      font-weight: 400;
      &[type='submit'] {
        background-color: ${theme.colours.blackText};
        color: #fff;
        padding-inline: 10px;
      }
      &.gray {
        background-color: ${theme.colours.silverChalice};
      }
    }
    .actions {
      display: flex;
      justify-content: space-between;
      gap: 8px;
      @media (max-width: 767px) {
        flex-direction: column;
        align-items: center;
      }
    }
    .button_container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: ${theme.space_size};
      flex-wrap: wrap;
    }
  }
`;
export const SelectedDataWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${theme.colours.Lotion};
  padding: 10px 0px;
  border-radius: 12px;
  margin-top: 9px;
  ul {
    list-style: none;
    li {
      display: flex;
      gap: 2px;
      align-items: center;
      color: ${theme.colours.SpanishGray};
    }
  }
  span.clear {
    color: ${theme.colours.mainBlue};
    cursor: pointer;
  }
  &.input_containers {
    background-color: transparent;
    ul {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 12px;
      li {
        gap: 24px;
        .ErrorMessageStyle {
          display: none;
        }

        .select_wrapper {
          width: 100%;
        }
        .input_wrapper {
          min-width: 35%;
          .gray_placeholder {
            margin: 0;
          }
          span.icon {
            top: calc(100% - 30px);
            left: 8px;
            cursor: pointer;
            svg {
              width: 20px;
              height: 20px;
            }
          }
        }
        @media (max-width: 1200px) {
          flex-direction: column;
          gap: 0;
          .input_wrapper {
            width: 100%;
          }
        }
      }
    }
    @media (max-width: 1200px) {
      padding: 0;
      margin-top: 0px;
      margin-bottom: 0px;
    }
  }
`;
